/*
 * @Author: chenxing
 * @Date: 2021-03-16 15:30:08
 * @LastEditors: chenxing
 * @LastEditTime: 2021-05-11 20:34:12
 */
export default {
    sysName: '泰坦智能',
    sysNameEN: 'TIAS'
};